export const countries = [
	{ code: '+93', flag: '🇦🇫', name: 'Afghanistan' },
	{ code: '+355', flag: '🇦🇱', name: 'Albania' },
	{ code: '+213', flag: '🇩🇿', name: 'Algeria' },
	{ code: '+1684', flag: '🇦🇸', name: 'American Samoa' },
	{ code: '+376', flag: '🇦🇩', name: 'Andorra' },
	{ code: '+244', flag: '🇦🇴', name: 'Angola' },
	{ code: '+1264', flag: '🇦🇮', name: 'Anguilla' },
	{ code: '+1268', flag: '🇦🇬', name: 'Antigua and Barbuda' },
	{ code: '+54', flag: '🇦🇷', name: 'Argentina' },
	{ code: '+374', flag: '🇦🇲', name: 'Armenia' },
	{ code: '+297', flag: '🇦🇼', name: 'Aruba' },
	{ code: '+61', flag: '🇦🇺', name: 'Australia' },
	{ code: '+43', flag: '🇦🇹', name: 'Austria' },
	{ code: '+994', flag: '🇦🇿', name: 'Azerbaijan' },
	{ code: '+1242', flag: '🇧🇸', name: 'Bahamas' },
	{ code: '+973', flag: '🇧🇭', name: 'Bahrain' },
	{ code: '+880', flag: '🇧🇩', name: 'Bangladesh' },
	{ code: '+1246', flag: '🇧🇧', name: 'Barbados' },
	{ code: '+375', flag: '🇧🇾', name: 'Belarus' },
	{ code: '+32', flag: '🇧🇪', name: 'Belgium' },
	{ code: '+501', flag: '🇧🇿', name: 'Belize' },
	{ code: '+229', flag: '🇧🇯', name: 'Benin' },
	{ code: '+1441', flag: '🇧🇲', name: 'Bermuda' },
	{ code: '+975', flag: '🇧🇹', name: 'Bhutan' },
	{ code: '+591', flag: '🇧🇴', name: 'Bolivia' },
	{ code: '+387', flag: '🇧🇦', name: 'Bosnia and Herzegovina' },
	{ code: '+267', flag: '🇧🇼', name: 'Botswana' },
	{ code: '+55', flag: '🇧🇷', name: 'Brazil' },
	{ code: '+246', flag: '🇮🇴', name: 'British Indian Ocean Territory' },
	{ code: '+673', flag: '🇧🇳', name: 'Brunei' },
	{ code: '+359', flag: '🇧🇬', name: 'Bulgaria' },
	{ code: '+226', flag: '🇧🇫', name: 'Burkina Faso' },
	{ code: '+257', flag: '🇧🇮', name: 'Burundi' },
	{ code: '+237', flag: '🇨🇲', name: 'Cameroon' },
	{ code: '+1', flag: '🇨🇦', name: 'Canada' },
	{ code: '+238', flag: '🇨🇻', name: 'Cape Verde' },
	{ code: '+1345', flag: '🇰🇾', name: 'Cayman Islands' },
	{ code: '+236', flag: '🇨🇫', name: 'Central African Republic' },
	{ code: '+235', flag: '🇹🇩', name: 'Chad' },
	{ code: '+56', flag: '🇨🇱', name: 'Chile' },
	{ code: '+86', flag: '🇨🇳', name: 'China' },
	{ code: '+61', flag: '🇨🇽', name: 'Christmas Island' },
	{ code: '+672', flag: '🇨🇨', name: 'Cocos (Keeling) Islands' },
	{ code: '+57', flag: '🇨🇴', name: 'Colombia' },
	{ code: '+269', flag: '🇰🇲', name: 'Comoros' },
	{ code: '+242', flag: '🇨🇬', name: 'Congo (Congo-Brazzaville)' },
	{ code: '+243', flag: '🇨🇩', name: 'Congo (Democratic Republic)' },
	{ code: '+682', flag: '🇨🇰', name: 'Cook Islands' },
	{ code: '+506', flag: '🇨🇷', name: 'Costa Rica' },
	{ code: '+385', flag: '🇭🇷', name: 'Croatia' },
	{ code: '+53', flag: '🇨🇺', name: 'Cuba' },
	{ code: '+599', flag: '🇨🇼', name: 'Curaçao' },
	{ code: '+357', flag: '🇨🇾', name: 'Cyprus' },
	{ code: '+420', flag: '🇨🇿', name: 'Czechia (Czech Republic)' },
	{ code: '+45', flag: '🇩🇰', name: 'Denmark' },
	{ code: '+253', flag: '🇩🇯', name: 'Djibouti' },
	{ code: '+1767', flag: '🇩🇲', name: 'Dominica' },
	{ code: '+1809', flag: '🇩🇴', name: 'Dominican Republic' },
	{ code: '+670', flag: '🇹🇱', name: 'East Timor (Timor-Leste)' },
	{ code: '+593', flag: '🇪🇨', name: 'Ecuador' },
	{ code: '+20', flag: '🇪🇬', name: 'Egypt' },
	{ code: '+503', flag: '🇸🇻', name: 'El Salvador' },
	{ code: '+240', flag: '🇬🇶', name: 'Equatorial Guinea' },
	{ code: '+291', flag: '🇪🇷', name: 'Eritrea' },
	{ code: '+372', flag: '🇪🇪', name: 'Estonia' },
	{ code: '+251', flag: '🇪🇹', name: 'Ethiopia' },
	{ code: '+500', flag: '🇫🇰', name: 'Falkland Islands' },
	{ code: '+298', flag: '🇫🇴', name: 'Faroe Islands' },
	{ code: '+679', flag: '🇫🇯', name: 'Fiji' },
	{ code: '+358', flag: '🇫🇮', name: 'Finland' },
	{ code: '+33', flag: '🇫🇷', name: 'France' },
	{ code: '+594', flag: '🇬🇫', name: 'French Guiana' },
	{ code: '+689', flag: '🇵🇫', name: 'French Polynesia' },
	{ code: '+241', flag: '🇬🇦', name: 'Gabon' },
	{ code: '+220', flag: '🇬🇲', name: 'Gambia' },
	{ code: '+995', flag: '🇬🇪', name: 'Georgia' },
	{ code: '+49', flag: '🇩🇪', name: 'Germany' },
	{ code: '+233', flag: '🇬🇭', name: 'Ghana' },
	{ code: '+350', flag: '🇬🇮', name: 'Gibraltar' },
	{ code: '+30', flag: '🇬🇷', name: 'Greece' },
	{ code: '+299', flag: '🇬🇱', name: 'Greenland' },
	{ code: '+1478', flag: '🇬🇩', name: 'Grenada' },
	{ code: '+590', flag: '🇬🇵', name: 'Guadeloupe' },
	{ code: '+1671', flag: '🇬🇺', name: 'Guam' },
	{ code: '+502', flag: '🇬🇹', name: 'Guatemala' },
	{ code: '+44', flag: '🇬🇬', name: 'Guernsey' },
	{ code: '+224', flag: '🇬🇳', name: 'Guinea' },
	{ code: '+245', flag: '🇬🇼', name: 'Guinea-Bissau' },
	{ code: '+592', flag: '🇬🇾', name: 'Guyana' },
	{ code: '+509', flag: '🇭🇹', name: 'Haiti' },
	{ code: '+504', flag: '🇭🇳', name: 'Honduras' },
	{ code: '+852', flag: '🇭🇰', name: 'Hong Kong' },
	{ code: '+36', flag: '🇭🇺', name: 'Hungary' },
	{ code: '+354', flag: '🇮🇸', name: 'Iceland' },
	{ code: '+91', flag: '🇮🇳', name: 'India' },
	{ code: '+62', flag: '🇮🇩', name: 'Indonesia' },
	{ code: '+98', flag: '🇮🇷', name: 'Iran' },
	{ code: '+964', flag: '🇮🇶', name: 'Iraq' },
	{ code: '+353', flag: '🇮🇪', name: 'Ireland' },
	{ code: '+44', flag: '🇮🇲', name: 'Isle of Man' },
	{ code: '+972', flag: '🇮🇱', name: 'Israel' },
	{ code: '+39', flag: '🇮🇹', name: 'Italy' },
	{ code: '+225', flag: '🇨🇮', name: 'Ivory Coast' },
	{ code: '+1876', flag: '🇯🇲', name: 'Jamaica' },
	{ code: '+81', flag: '🇯🇵', name: 'Japan' },
	{ code: '+44', flag: '🇯🇪', name: 'Jersey' },
	{ code: '+962', flag: '🇯🇴', name: 'Jordan' },
	{ code: '+7', flag: '🇰🇿', name: 'Kazakhstan' },
	{ code: '+254', flag: '🇰🇪', name: 'Kenya' },
	{ code: '+686', flag: '🇰🇮', name: 'Kiribati' },
	{ code: '+383', flag: '🇽🇰', name: 'Kosovo' },
	{ code: '+965', flag: '🇰🇼', name: 'Kuwait' },
	{ code: '+996', flag: '🇰🇬', name: 'Kyrgyzstan' },
	{ code: '+856', flag: '🇱🇦', name: 'Laos' },
	{ code: '+371', flag: '🇱🇻', name: 'Latvia' },
	{ code: '+961', flag: '🇱🇧', name: 'Lebanon' },
	{ code: '+266', flag: '🇱🇸', name: 'Lesotho' },
	{ code: '+231', flag: '🇱🇷', name: 'Liberia' },
	{ code: '+218', flag: '🇱🇾', name: 'Libya' },
	{ code: '+423', flag: '🇱🇮', name: 'Liechtenstein' },
	{ code: '+370', flag: '🇱🇹', name: 'Lithuania' },
	{ code: '+352', flag: '🇱🇺', name: 'Luxembourg' },
	{ code: '+853', flag: '🇲🇴', name: 'Macau' },
	{ code: '+389', flag: '🇲🇰', name: 'North Macedonia (formerly Macedonia)' },
	{ code: '+261', flag: '🇲🇬', name: 'Madagascar' },
	{ code: '+265', flag: '🇲🇼', name: 'Malawi' },
	{ code: '+60', flag: '🇲🇾', name: 'Malaysia' },
	{ code: '+960', flag: '🇲🇻', name: 'Maldives' },
	{ code: '+223', flag: '🇲🇱', name: 'Mali' },
	{ code: '+356', flag: '🇲🇹', name: 'Malta' },
	{ code: '+692', flag: '🇲🇭', name: 'Marshall Islands' },
	{ code: '+596', flag: '🇲🇶', name: 'Martinique' },
	{ code: '+222', flag: '🇲🇷', name: 'Mauritania' },
	{ code: '+230', flag: '🇲🇺', name: 'Mauritius' },
	{ code: '+262', flag: '🇾🇹', name: 'Mayotte' },
	{ code: '+52', flag: '🇲🇽', name: 'Mexico' },
	{ code: '+691', flag: '🇫🇲', name: 'Micronesia' },
	{ code: '+373', flag: '🇲🇩', name: 'Moldova' },
	{ code: '+377', flag: '🇲🇨', name: 'Monaco' },
	{ code: '+976', flag: '🇲🇳', name: 'Mongolia' },
	{ code: '+382', flag: '🇲🇪', name: 'Montenegro' },
	{ code: '+1664', flag: '🇲🇸', name: 'Montserrat' },
	{ code: '+212', flag: '🇲🇦', name: 'Morocco' },
	{ code: '+258', flag: '🇲🇿', name: 'Mozambique' },
	{ code: '+95', flag: '🇲🇲', name: 'Myanmar (Burma)' },
	{ code: '+264', flag: '🇳🇦', name: 'Namibia' },
	{ code: '+674', flag: '🇳🇷', name: 'Nauru' },
	{ code: '+977', flag: '🇳🇵', name: 'Nepal' },
	{ code: '+31', flag: '🇳🇱', name: 'Netherlands' },
	{ code: '+687', flag: '🇳🇨', name: 'New Caledonia' },
	{ code: '+64', flag: '🇳🇿', name: 'New Zealand' },
	{ code: '+505', flag: '🇳🇮', name: 'Nicaragua' },
	{ code: '+227', flag: '🇳🇪', name: 'Niger' },
	{ code: '+234', flag: '🇳🇬', name: 'Nigeria' },
	{ code: '+683', flag: '🇳🇺', name: 'Niue' },
	{ code: '+672', flag: '🇳🇫', name: 'Norfolk Island' },
	{ code: '+850', flag: '🇰🇵', name: 'North Korea' },
	{ code: '+1670', flag: '🇲🇵', name: 'Northern Mariana Islands' },
	{ code: '+47', flag: '🇳🇴', name: 'Norway' },
	{ code: '+968', flag: '🇴🇲', name: 'Oman' },
	{ code: '+92', flag: '🇵🇰', name: 'Pakistan' },
	{ code: '+680', flag: '🇵🇼', name: 'Palau' },
	{ code: '+970', flag: '🇵🇸', name: 'Palestine State' },
	{ code: '+507', flag: '🇵🇦', name: 'Panama' },
	{ code: '+675', flag: '🇵🇬', name: 'Papua New Guinea' },
	{ code: '+595', flag: '🇵🇾', name: 'Paraguay' },
	{ code: '+51', flag: '🇵🇪', name: 'Peru' },
	{ code: '+63', flag: '🇵🇭', name: 'Philippines' },
	{ code: '+48', flag: '🇵🇱', name: 'Poland' },
	{ code: '+351', flag: '🇵🇹', name: 'Portugal' },
	{ code: '+1787', flag: '🇵🇷', name: 'Puerto Rico' },
	{ code: '+974', flag: '🇶🇦', name: 'Qatar' },
	{ code: '+242', flag: '🇷🇪', name: 'Réunion' },
	{ code: '+40', flag: '🇷🇴', name: 'Romania' },
	{ code: '+7', flag: '🇷🇺', name: 'Russia' },
	{ code: '+250', flag: '🇷🇼', name: 'Rwanda' },
	{ code: '+590', flag: '🇧🇱', name: 'Saint Barthélemy' },
	{ code: '+290', flag: '🇸🇭', name: 'Saint Helena' },
	{ code: '+1869', flag: '🇰🇳', name: 'Saint Kitts and Nevis' },
	{ code: '+1758', flag: '🇱🇨', name: 'Saint Lucia' },
	{ code: '+590', flag: '🇲🇫', name: 'Saint Martin' },
	{ code: '+508', flag: '🇵🇲', name: 'Saint Pierre and Miquelon' },
	{ code: '+1784', flag: '🇻🇨', name: 'Saint Vincent and the Grenadines' },
	{ code: '+685', flag: '🇼🇸', name: 'Samoa' },
	{ code: '+378', flag: '🇸🇲', name: 'San Marino' },
	{ code: '+239', flag: '🇸🇹', name: 'São Tomé and Príncipe' },
	{ code: '+966', flag: '🇸🇦', name: 'Saudi Arabia' },
	{ code: '+221', flag: '🇸🇳', name: 'Senegal' },
	{ code: '+381', flag: '🇷🇸', name: 'Serbia' },
	{ code: '+248', flag: '🇸🇨', name: 'Seychelles' },
	{ code: '+232', flag: '🇸🇱', name: 'Sierra Leone' },
	{ code: '+65', flag: '🇸🇬', name: 'Singapore' },
	{ code: '+1721', flag: '🇸🇽', name: 'Sint Maarten' },
	{ code: '+421', flag: '🇸🇰', name: 'Slovakia' },
	{ code: '+386', flag: '🇸🇮', name: 'Slovenia' },
	{ code: '+677', flag: '🇸🇧', name: 'Solomon Islands' },
	{ code: '+252', flag: '🇸🇴', name: 'Somalia' },
	{ code: '+27', flag: '🇿🇦', name: 'South Africa' },
	{ code: '+82', flag: '🇰🇷', name: 'South Korea' },
	{ code: '+211', flag: '🇸🇸', name: 'South Sudan' },
	{ code: '+34', flag: '🇪🇸', name: 'Spain' },
	{ code: '+94', flag: '🇱🇰', name: 'Sri Lanka' },
	{ code: '+249', flag: '🇸🇩', name: 'Sudan' },
	{ code: '+597', flag: '🇸🇷', name: 'Suriname' },
	{ code: '+47', flag: '🇸🇯', name: 'Svalbard and Jan Mayen' },
	{ code: '+268', flag: '🇸🇿', name: 'Eswatini (fmr. "Swaziland")' },
	{ code: '+46', flag: '🇸🇪', name: 'Sweden' },
	{ code: '+41', flag: '🇨🇭', name: 'Switzerland' },
	{ code: '+963', flag: '🇸🇾', name: 'Syria' },
	{ code: '+886', flag: ' Taiwan' },
	{ code: '+992', flag: '🇹🇯', name: 'Tajikistan' },
	{ code: '+255', flag: '🇹🇿', name: 'Tanzania' },
	{ code: '+66', flag: '🇹🇭', name: 'Thailand' },
	{ code: '+228', flag: '🇹🇬', name: 'Togo' },
	{ code: '+690', flag: '🇹🇰', name: 'Tokelau' },
	{ code: '+676', flag: '🇹🇴', name: 'Tonga' },
	{ code: '+1868', flag: '🇹🇹', name: 'Trinidad and Tobago' },
	{ code: '+216', flag: '🇹🇳', name: 'Tunisia' },
	{ code: '+90', flag: '🇹🇷', name: 'Turkey' },
	{ code: '+993', flag: '🇹🇲', name: 'Turkmenistan' },
	{ code: '+1649', flag: '🇹🇨', name: 'Turks and Caicos Islands' },
	{ code: '+688', flag: '🇹🇻', name: 'Tuvalu' },
	{ code: '+256', flag: '🇺🇬', name: 'Uganda' },
	{ code: '+380', flag: '🇺🇦', name: 'Ukraine' },
	{ code: '+971', flag: '🇦🇪', name: 'United Arab Emirates' },
	{ code: '+44', flag: '🇬🇧', name: 'United Kingdom' },
	{ code: '+1', flag: '🇺🇸', name: 'United States' },
	{ code: '+598', flag: '🇺🇾', name: 'Uruguay' },
	{ code: '+998', flag: '🇺🇿', name: 'Uzbekistan' },
	{ code: '+678', flag: '🇻🇺', name: 'Vanuatu' },
	{ code: '+379', flag: '🇻🇦', name: 'Vatican City' },
	{ code: '+58', flag: '🇻🇪', name: 'Venezuela' },
	{ code: '+84', flag: '🇻🇳', name: 'Vietnam' },
	{ code: '+681', flag: '🇼🇫', name: 'Wallis and Futuna' },
	{ code: '+248', flag: '🇾🇪', name: 'Yemen' },
	{ code: '+260', flag: '🇿🇲', name: 'Zambia' },
	{ code: '+263', flag: '🇿🇼', name: 'Zimbabwe' },
];
